/**
 * Newsletter Component
 * Handles newsletter form submission with ActiveCampaign integration
 */

import Alpine from 'alpinejs';

Alpine.data('newsletter', (formUrl = '') => ({
  email: '',
  consent: false,
  status: 'idle', // idle, loading, success, error
  errorMessage: '',

  get isValid() {
    return this.email && this.email.includes('@') && this.consent;
  },

  get isLoading() {
    return this.status === 'loading';
  },

  get isSuccess() {
    return this.status === 'success';
  },

  get isError() {
    return this.status === 'error';
  },

  async submit() {
    if (!this.isValid || this.isLoading) return;

    // Check if form URL is configured
    if (!formUrl) {
      this.status = 'success';
      this.email = '';
      this.consent = false;
      return;
    }

    this.status = 'loading';
    this.errorMessage = '';

    try {
      const formData = new FormData();
      formData.append('email', this.email);

      const response = await fetch(formUrl, {
        method: 'POST',
        body: formData,
        mode: 'no-cors', // ActiveCampaign forms typically require this
      });

      // With no-cors, we can't read the response, so assume success
      this.status = 'success';
      this.email = '';
      this.consent = false;
    } catch (error) {
      console.error('[Newsletter] Subscription error:', error);
      this.status = 'error';
      this.errorMessage = 'Error al suscribirse. Por favor, intenta de nuevo.';
    }
  },

  reset() {
    this.status = 'idle';
    this.errorMessage = '';
  },
}));

export default {};
